import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bfbe690"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "value"]
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.allowDisable)
          ? (_openBlock(), _createBlock(_component_InputCheckboxBoolean, {
              key: 0,
              modelValue: _ctx.enabled,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabled) = $event)),
                _ctx.onEnabledChanged
              ],
              label: _ctx.label,
              name: `${_ctx.name} enabled`,
              errors: _ctx.errors
            }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.enabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({'mt-2': _ctx.allowDisable})
            }, [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.localDto.unit_dimension.value,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localDto.unit_dimension.value) = $event)),
                  _ctx.emitModelChanged
                ],
                name: _ctx.fieldName,
                label: _ctx.valueLabel,
                mode: "group-end",
                "addon-text": _ctx.fixedUnitLabel,
                min: _ctx.min,
                placeholder: _ctx.placeholder,
                fieldClass: _ctx.placeholder ? 'dp-label-floated' : '',
                errors: _ctx.errors
              }, _createSlots({ _: 2 }, [
                (!_ctx.fixedUnit)
                  ? {
                      name: "afterInput",
                      fn: _withCtx(() => [
                        _createElementVNode("select", {
                          class: "form-select form-select-sm unit-select",
                          "aria-label": _ctx.unitLabel,
                          value: _ctx.localDto.unit_dimension.unit_code,
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onUnitChanged && _ctx.onUnitChanged(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unitOptions, (unitOption) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: unitOption.code,
                              value: unitOption.code
                            }, _toDisplayString(unitOption.description), 9, _hoisted_2))
                          }), 128))
                        ], 40, _hoisted_1)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue", "name", "label", "addon-text", "min", "placeholder", "fieldClass", "errors", "onUpdate:modelValue"])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}